'use client';

import Error from 'next/error';

import { LOCALES } from '@commons/i18n';

/**
 * This page renders when a route like `/unknown.txt` is requested.
 *
 * In this case, the layout at `app/[locale]/layout.tsx` receives an invalid value as the `[locale]` param and calls `notFound()`.
 *
 * @see https://github.com/amannn/next-intl/blob/main/examples/example-app-router/src/app/not-found.tsx
 */

const GlobalNotFound = () => (
  <html lang={LOCALES.EN}>
    <body>
      <Error statusCode={404} />
    </body>
  </html>
);

export default GlobalNotFound;
